import { useTranslation } from 'react-i18next'
import { LearningContentText } from '@quebon/shared-learning/components/common/LearningContentText'

interface Props {
  correctCriteria?: string | null
  checkPoint?: string | null
}

export function getQuizReviewMetadata(snapshot: unknown): Props {
  if (!snapshot || typeof snapshot !== 'object') {
    return { correctCriteria: null, checkPoint: null }
  }

  const candidate = snapshot as { correctCriteria?: unknown; checkPoint?: unknown }
  return {
    correctCriteria: typeof candidate.correctCriteria === 'string'
      ? candidate.correctCriteria
      : null,
    checkPoint: typeof candidate.checkPoint === 'string'
      ? candidate.checkPoint
      : null,
  }
}

function MetadataRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="grid gap-1 sm:grid-cols-[112px_minmax(0,1fr)] sm:gap-3">
      <dt className="text-xs font-semibold text-muted-foreground">{label}</dt>
      <dd className="whitespace-pre-wrap text-sm leading-6 text-foreground">
        <LearningContentText text={value} />
      </dd>
    </div>
  )
}

export function QuizReviewMetadata({ correctCriteria, checkPoint }: Props) {
  const { t } = useTranslation('coaching')
  const criteria = correctCriteria?.trim()
  const teacherCheck = checkPoint?.trim()

  if (!criteria && !teacherCheck) return null

  return (
    <section
      aria-label={t('quizReference.ariaLabel')}
      className="rounded-lg border border-border bg-muted/40 p-3"
    >
      <dl className="space-y-2.5">
        {criteria ? (
          <MetadataRow label={t('quizReference.correctCriteria')} value={criteria} />
        ) : null}
        {teacherCheck ? (
          <MetadataRow label={t('quizReference.checkPoint')} value={teacherCheck} />
        ) : null}
      </dl>
    </section>
  )
}
